import React, {
  FC,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import LeftToRight from '../components/Animation/LeftToRight';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import RobotReply from '../components/Reply/RobotReply';
import InterRegularText from '../../../../../components/Text/InterRegularText';
import InterSemiBoldText from '../../../../../components/Text/InterSemiBoldText';

const Q12: FC<Props> = ({
  type,
}) => {

  return (
    <LeftToRight flowId={uuid()}>
      <RowLeft style={{ marginTop: 32 }}>
        <RobotReply
          langZh={'这个智能柜目前没有配送物品存放其中。可查看其他地点或联系配送平台。'}
          langEn={(
            <InterRegularText fontSize={16} lineHeight={19}>
              This locker <InterSemiBoldText fontSize={16} lineHeight={19} isSpan={true}>currently has no{type === 'Food' ? ' food ' : (type === 'Parcel' ? ' parcel ' : ' ')}deliveries in it.</InterSemiBoldText>
              <br /><br />
              See alternative storage place or contact delivery platform.
            </InterRegularText>
          )}
          style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
        />
      </RowLeft>
    </LeftToRight>
  );
};

export interface Props {
  type?: 'Food' | 'Parcel';
}

export default Q12;
